import useCallApi from '../../utilities/axios'

export type RiskProjectRequest = {
    keyword?: string
    userID: number | null
}

export type RiskProject = {
    projectID: number
    projectNumber: string
    closedDate: string
    receiveDate: string
    projectName: Translation
    projectType: {
        id: number
        name: Translation
    }
    name: Translation
    title: Translation
    titleID: number
    academicPosition: Translation
    isPhD: boolean
    researcherTypeName: Translation
}

type Translation = {
    th: string
    en: string
}

export const useSearchRiskProjectSummary = () => {
    const callApi = useCallApi()

    const searchHighRiskProject = async (values: RiskProjectRequest) => {
        const { data } = await callApi.axiosPost({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/dashboard/search/project/high-risk`,
            params: { ...values },
        })

        return data
    }

    return {
        searchHighRiskProject,
    }
}
